import { styled } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import FlexBox from 'components/flexbox/FlexBox';
import SearchInput from 'components/input-fields/SearchInput';
// import { H6 } from "components/Typography";
// import Apps from "icons/Apps";
// import FormatBullets from "icons/FormatBullets";
import React from 'react';
// import { useState } from "react";
import ExportExcel from 'utils/ExportExcel';
// import { useLocation, useNavigate } from "react-router-dom";
// import { lightTheme } from "../../constants";
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    flexWrap: 'wrap',
    margin: '24px 0',
    [theme.breakpoints.down(550)]: {
        '& .MuiInputBase-root': {
            maxWidth: 'calc(100% - 90px)',
        },
    },
})); // --------------------------------------------------------------------

// --------------------------------------------------------------------
const SearchArea = ({ value, onChange, setValue, data }) => {
    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Search..."
                value={value || ''}
                onChange={(e) => {
                    if (onChange && setValue) {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }

                    onChange(e.target.value);
                }}
            />

            <FlexBox alignItems="center" gap={1}>
                <ExportExcel
                    excelData={data}
                    fileName={'Data Purchased Workshops'}
                />
            </FlexBox>
        </SecondaryWrapper>
    );
};

export default SearchArea;
